const formFields = [
  {
    label: 'Production Equipment',
    key: 'name',
    isRequired: true,
  },
  {
    label: 'Available',
    key: 'available',
    type: 'select',
    options: [
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' },
    ],
  },
  {
    label: 'Adequate',
    key: 'adequate',
    type: 'select',
    options: [
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' },
    ],
  },
  {
    label: 'Ramp-up / Failover Time',
    key: 'rampUpTime',
    type: 'time',
    decoratorWord: 'months',
  },
  { type: 'autocomplete' },
];

export { formFields };
